export default __webpack_public_path__ + "static/media/Honored Helm of the Tribes.6cefed1b.jpg";